import React from "react";
import { useDispatch } from "react-redux";
import { getBeneficiary } from "../../../store/beneficiary/actions";
import { insured } from "../../../store/insured/actions";
import { personByIdClearData } from "../../../store/person/actions";
import { policyCancel } from "../../../store/policy/actions";
import { cancelQuote } from "../../../store/cancelQuote/actions";
import LocalStorageService from "../../../services/localStorage";

import { quoteAllClearData } from "../../../store/generateQuote/actions";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useNavigate } from "react-router-dom";
import { navigateBack, navigateNext } from "../../../dataBase/stepProgress";

const useUI = (
  setShowBeneficiariesModal: any,
  setShowInsuredModal: any,
  id: any,
  STEP: any,
  isValid: any,
  setSeeToast: any,
  setOpenModalConfirm: any,
  setPolicyId: any,
  setType: any,
  setModalTitle: any,
  setTriggerCatalogs: any,
) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const storageKey2 = "afy-login";
const lsLogin = new LocalStorageService(storageKey2);

  const handleClickContextMenu = (item: any, row: any) => {
    let data = row.row;
    console.log(data,item);
    let productId = data?.productId;
    if (item.name === "Beneficiarios") {
      dispatch(
        getBeneficiary({
          enable: true,
          page: 1,
          limit: 100,
          quoteId: data.id,
        }),
      );

      setShowBeneficiariesModal(true);
    }
    if (item.name === "Asegurados") {
      dispatch(
        insured({
          enable: true,
          page: 1,
          limit: 100,
          quoteId: data.id,
        }),
      );
      setShowInsuredModal(true);
    }
    if (item.name === "Ver detalles") {
      if (
        data.estado === "Expirada" ||
        data.estado === "Cancelada" ||
        data.estado === "Emitida"
      ) {
        navigate(`/confirmationForm/${data.id}/false/false/${productId}`);
      } else {
        navigate(`/confirmationForm/${data.id}/true/false/${productId}`);
      }
    }
    if (item.name === "Cancelar") {
      // Safety check: Don't allow cancellation of already cancelled or expired policies
      if (data.estado === "Cancelada" || 
          data.estado === "cancelada" || 
          data.estado === "Expirada" || 
          data.estado === "expirada") {
        console.log("Cannot cancel policy with status:", data.estado);
        setSeeToast({
          show: true,
          message: "No se puede cancelar una póliza que ya está " + data.estado.toLowerCase(),
          type: typeAlert.warning,
        });
        return;
      }
      
      if (data.estado === "Cotizada" || data.estado === "cotizada") {
        setModalTitle("cotización");
        setPolicyId(data.id); // Use quote ID for quotes
        setType(false); // false for quote, true for policy
      } else if (data.estado === "Emitida") {
        setModalTitle("póliza");
        setPolicyId(data.policyId || data.id); // Use policy ID for policies, fallback to quote ID
        setType(true); // true for policy
      }
      setTriggerCatalogs(true); // Trigger catalog loading
      setOpenModalConfirm(true);
    } 
  };

  const handleCancelPolicy = (reasonId: any, type: boolean, policyId: string) => {
    //get current date and time
    let currentDateAndTime = new Date();
    let currentDate = currentDateAndTime.toISOString();
    
    if (type) {
      // Cancel policy
      const dataSubmit = {
        data: {
          date: currentDate,
          userId: "d2bd577e-c8c6-4519-b30a-b8e674c42952", // This should be from user context
          policyId: policyId,
          catalogReasonCancellation: reasonId,
        },
      };
      dispatch(policyCancel(dataSubmit));
    } else {
      // Cancel quote
      dispatch(
        cancelQuote({
          id: policyId,
        }),
      );
    }
  };

  const handleClickPrevious = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (id) {
      navigate("/clients");
    } else {
      dispatch(personByIdClearData());
      dispatch(quoteAllClearData());
      navigateBack(STEP, navigate);
      //navigate("/plan");
    }
  };

  const handleClickNext = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isValid() === true) {
      dispatch(personByIdClearData());
      //navigate("/customerForm");
      navigateNext(STEP, navigate);
    } else {
      /*Cuando no se tiene ningun plan selecionado */
      setSeeToast({
        show: true,
        message: "¡Debe ingrensar un documento válido!",
        type: typeAlert.info,
      });
    }
  };
  return {
    handleClickContextMenu,
    handleClickPrevious,
    handleClickNext,
    handleCancelPolicy,
  };
};
export default useUI;
